export default (client) => ({
  get(filterParams) {
    return client.request({
      method: 'get',
      url: '/organizations/get',
      params: { ...filterParams },
    });
  },
});
